import formAppConfigs from './formAppConfigs';
import formConfigInfo from './formConfigInfo';

export default {
  title: 'White Label Play Config Rules',
  attributeName: 'appConfigs',
  getURL: 'apps/appId/configs/id/data',
  createURL: 'apps/appId/configs/id/data',
  updateURL: 'apps/appId/configs/id/data',
  removeURL: 'apps/appId/configs/id/data',
  idAttribute: 'configId',
  sessionParams: ['appId', 'areaId'],
  formConfig: [formConfigInfo, formAppConfigs],
  autoUpdate: false,
  noUpdateWithId: true,
  idUpdate:true,
  noArea: true,
  goBack: false,
  formGroupExpands: true,
};

